import { render, staticRenderFns } from "./TakeoverDate.vue?vue&type=template&id=84a5760a"
import script from "./TakeoverDate.vue?vue&type=script&lang=js"
export * from "./TakeoverDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports